import React, { PureComponent } from "react";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  // Rectangle,
  // LabelList,
  ResponsiveContainer,
  BarChart,
  Bar,
  // Cell,
  Legend,
  Tooltip,
  LabelList,
  ReferenceLine,
  Cell
} from "recharts";
import styles from "./Charts.local.scss";
import {
  CustomizedXAxisTick,
  CustomizedYAxisTick,
  CustomTooltip,
  COLORS
} from "./Common";
import { abbreviateNumber } from "Utils";
import { Modal } from "antd";

const colors = [
  "#2495E1",
  "#F84154",
  "#FA9437",
  "#06d9b1",
  "#73B7FF",
  "#95FFD7"
  // "#2495E1",
  // "#73B7FF",
  // "#F84154",
  // "#FE5C3D",
  // "#FA9437",
  // "#D0A679",
  // "#06d9b1",
  // "#95FFD7",
  // "#F7953E"
];

export class CustomizedLabel extends PureComponent {
  render() {
    const { x, y, width, value, color } = this.props;
    const offset = 10;
    const isNegative = value < 0;

    return (
      <g>
        <text
          x={x + width / 2}
          y={y ? (value >= 0 ? y - offset : y + offset) : 0}
          fill={isNegative ? "#fb185c" : "#2495e1"}
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize={10.5}
        >
          {value !== "N/A" ? abbreviateNumber(value) : ""}
        </text>
      </g>
    );
  }
}

export class StandardBarChart extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      selectedYear: null,
      selectedYearDetails: {}
    };
  }

  handleBarClick = data => {
    const { activeLabel } = data && data;
    const selectedYearDetails = this.props.chartData.find(
      item => item[this.props.dataKeyX] === activeLabel && activeLabel
    );
    this.setState({
      showModal: true,
      selectedYear: activeLabel,
      selectedYearDetails
    });
  };

  handleClose = () => {
    this.setState({
      showModal: false,
      selectedYear: null,
      selectedYearDetails: {}
    });
  };

  renderInnerBarChart(legendLabels) {
    const { selectedYearDetails } = this.state;

    if (selectedYearDetails && !selectedYearDetails.children) {
      return null;
    }

    const formattedData =
      selectedYearDetails &&
      selectedYearDetails.children &&
      Object.values(selectedYearDetails.children)
        .filter(child => child.label !== "")
        .map(child => ({
          name: child.label,
          value: child.value
        }));

    return (
      <Modal
        title={`${legendLabels} pour l'année ${this.state.selectedYear}`}
        visible={this.state.showModal}
        onOk={this.handleClose}
        onCancel={this.handleClose}
        width={1200}
        bodyStyle={{ maxHeight: "90vh", overflowY: "auto" }}
        footer={null}
      >
        <ResponsiveContainer width="100%" height={550}>
          <BarChart data={formattedData}>
            <Legend
              layout="horizontal"
              verticalAlign="top"
              align="center"
              height={100}
              payload={
                formattedData &&
                formattedData.map((entry, index) => ({
                  value: entry.name,
                  type: "square",
                  color: COLORS[index % COLORS.length]
                }))
              }
            />
            <Tooltip
              cursor={{ fill: "#f3faff", opacity: 0.6 }}
              content={<CustomTooltip />}
            />
            <CartesianGrid
              vertical={false}
              stroke="#6d7f92"
              strokeWidth={0.2}
            />
            <XAxis dataKey="name" axisLine={false} tick={false} />
            <YAxis
              tick={<CustomizedYAxisTick currency="€" />}
              axisLine={false}
              tickLine={false}
              type={"number"}
            />
            <Bar
              dataKey="value"
              fill={colors[0]}
              animationEasing={"ease-in-out"}
              animationDuration={800}
              barSize={65}
              minPointSize={2}
            >
              {formattedData &&
                formattedData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              <LabelList
                dataKey="value"
                position="top"
                content={<CustomizedLabel />}
              />
            </Bar>
            <ReferenceLine y={0} stroke="#00000080" strokeWidth={1} />
          </BarChart>
        </ResponsiveContainer>
      </Modal>
    );
  }

  render() {
    const {
      chartData,
      dataKeysY,
      dataKeyX,
      currency,
      legendLabels,
      containerWidth,
      containerHeight
    } = this.props;
    return (
      <React.Fragment>
        <ResponsiveContainer
          width={containerWidth ? containerWidth : "100%"}
          height={containerHeight ? containerHeight : 340}
          className={styles.charts_font}
        >
          <BarChart
            data={chartData}
            margin={{ top: 15, right: 40, left: 15, bottom: 0 }}
            onClick={e => this.handleBarClick(e)}
          >
            <CartesianGrid
              vertical={false}
              stroke="#6d7f92"
              strokeWidth={0.2}
            />
            <XAxis
              name={dataKeyX}
              dataKey={dataKeyX}
              height={50}
              interval={0}
              padding={{ left: 20, right: 20 }}
              type="category"
              tick={<CustomizedXAxisTick />}
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              tick={<CustomizedYAxisTick currency={currency} />}
              axisLine={false}
              tickLine={false}
              type={"number"}
            />
            <Tooltip
              cursor={{ fill: "#f3faff", opacity: 0.6 }}
              content={<CustomTooltip />}
            />
            <Legend
              verticalAlign="top"
              height={containerHeight ? 20 : 70}
              // align={"center"}
              iconType={"square"}
              iconSize={12}
              layout={containerHeight ? "horizontal" : "vertical"}
              wrapperStyle={{
                left: 42,
                top: 0,
                fontWeight: 300,
                fontSize: "14px"
              }}
            />
            <ReferenceLine y={0} stroke="#6d7f9271" />

            {dataKeysY.map((item, i) => {
              return (
                <Bar
                  key={i}
                  name={legendLabels[i]}
                  type="monotone"
                  dataKey={dataKeysY[i]}
                  barSize={65}
                  radius={[4, 4, 4, 4]}
                  fill={colors[i]}
                  // label={{ position: "top" }}
                  animationEasing={"ease-in-out"}
                  animationDuration={800}
                  minPointSize={2}
                >
                  {/*{chartData.map((entry, index) => (*/}
                  {/*  <Cell key={`cell-${index}`} fill={colors[i]} />*/}
                  {/*))}*/}
                  <LabelList
                    dataKey={dataKeysY[i]}
                    content={<CustomizedLabel color={colors[i]} />}
                  />
                </Bar>
              );
            })}
          </BarChart>
        </ResponsiveContainer>
        {this.renderInnerBarChart(legendLabels)}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/Charts/StandardBarChart.js